import {Regex} from 'commons/constants';
import {ExpectedValue} from 'commons/types/Types';
import {notEmpty} from 'commons/utils/Functions';

// todo: setup messages
const notEmail = 'El campo no es un email';
const notRFC = 'El campo no es un RFC';

/**
 * Trim string
 * @param {string} value
 * @returns {string}
 */
function trimStr(value: string) {
    return value.trim();
}

/**
 * Email Regex Validation
 * @param {string} value: Not empty string
 * @returns {boolean}: True: Value is an email
 */
function isEmail(value: string) {
    return Regex.EMAIL.test(value);
}

/**
 *  RFC Regex Validation
 * @param {string} value
 * @returns {undefined | string}
 */
function isRfc(value: string) {
    const match = Regex.RFC.test(value);
    return match ? undefined : notRFC;
}

/**
 * Form email field validation
 * @param {string} value: string to validate
 * @returns {string | undefined}
 */
function email(value: string) {
    let valid = false;
    /** If not empty */
    if (notEmpty(value)) {
        valid = isEmail(trimStr(value));
    }
    return valid ? null : notEmail;
}

/**
 * Form dirty field validation
 * @param {string | number} value: string or number value
 * @returns {string | number | boolean}:
 */
function isDirty(value: ExpectedValue) {
    return value || value === 0;
}

/**
 * Length field validation
 * @param {string} value
 * @param {number} max
 * @returns {string}
 */
function hasLength(value: string, max: number) {
    // todo: setup message
    return value.length + '/' + max;
}

/**
 * Required fields validation
 * @param {readonly string[]} requires
 * @param {Record<string, string>} values
 * @returns {Record<string, string>}
 */
function required(
    requires: readonly string[],
    values: Record<string, ExpectedValue>
): Record<string, string> {
    return requires.reduce(
        (fields: Record<string, string>, field) => ({
            ...fields,
            ...(isDirty(values[field])
                ? ''
                : {[field]: `El campo ${field} es obligatorio`}),
        }),
        {}
    );
}

const Validations = {
    email: (value: string) => email(value),
    dirty: (value: string) => isDirty(value),
    required: (requires: string[], fields: Record<string, ExpectedValue>) =>
        required(requires, fields),
    rfc: (value: string) => isRfc(value),
    length: (value: string, length: number) => hasLength(value, length),
};

export default Validations;
